import { AbstractApiModel } from './abstract-api-model';

export class SystemCheck extends AbstractApiModel<SystemCheck> {
  check: string;
  status: string;
  message: string;
  output: string;
  subsystem: string;

  deserialize(json: any): this {
    this.check = json.check;
    this.status = json.status;
    this.message = json.message;
    this.output = json.output;
    this.subsystem = json.subsytem;
    return this;
  }
}
